import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AdminState {
  isAuthenticated: boolean;
  name: string | null;
}

const initialState: AdminState = {
  isAuthenticated: false,
  name: null
};

export const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    login(state, action: PayloadAction<string>) {
      state.isAuthenticated = true;
      state.name = action.payload;
    },
    logout(state) {
      state.isAuthenticated = false;
      state.name = null;
    }
  }
});

export const { login, logout } = adminSlice.actions;
export default adminSlice.reducer;
